import { render, staticRenderFns } from "./ot-claims-index.vue?vue&type=template&id=eae9fc00&scoped=true&"
import script from "./ot-claims-index.vue?vue&type=script&lang=ts&"
export * from "./ot-claims-index.vue?vue&type=script&lang=ts&"
import style0 from "./ot-claims-index.vue?vue&type=style&index=0&id=eae9fc00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae9fc00",
  null
  
)

export default component.exports